// extracted by mini-css-extract-plugin
export default {"toolbarGoBack":"GoBack_toolbarGoBack__t7fOR","icon":"GoBack_icon__0zwNn"};